(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("myTier", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/gamification/myTierView.html",
            controller: ["myAccountResource", "messageService", "frameworkService", "$translate", "colorService", "$state", "_", MyTierCtrl],
            controllerAs: "vm"
        };
        function MyTierCtrl(myAccountResource, messageService, frameworkService, $translate, colorService, $state, _) {
            var vm = this;
            vm.loading = true;
            vm.isMobile = jQuery.browser.mobile;
            if (!frameworkService.data.tenantFeatures.gamificationTierSystem) {
                $state.go("main.notFound");
                return;
            }
            myAccountResource.getMyTierDashboard(function (data) {
                vm.data = data;
                vm.chartOptions = { thickness: 40 };
                vm.chart = [
                    { label: $translate.instant("common.assignmentStatus.Completed"), value: vm.data.completionStats.completed, color: colorService.getSuccessColor(), legend: "gamification.myTier.assignment.chart.legend.completed", cssClass: "text-completed" },
                    { label: $translate.instant("common.assignmentStatus.Assigned"), value: vm.data.completionStats.assigned, color: colorService.getWarningColor(), legend: "gamification.myTier.assignment.chart.legend.assigned", cssClass: "text-assigned" },
                    { label: $translate.instant("common.assignmentStatus.Expired"), value: vm.data.completionStats.expired, color: colorService.getDangerColor(), legend: "gamification.myTier.assignment.chart.legend.expired", cssClass: "text-expired" }
                ];
                //Show a gray chart if there is no assigned learning
                if (vm.data.completionStats.completed === 0 && vm.data.completionStats.assigned === 0 && vm.data.completionStats.expired === 0)
                    vm.chart.push({ label: "", value: 100, color: "#c8c5c5" });
                vm.data.allTiers = _.map(vm.data.allTiers, function (item, index) {
                    item.width = vm.width(item, vm.data.allTiers[index + 1]);
                    return item;
                });
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
            vm.width = function (tier, nextTier) {
                if (!nextTier) //at the max already
                    return vm.data.myCurrentTier.percentCompletion;
                if (vm.data.myCurrentTier.percentCompletion > tier.percentCompletion && vm.data.myCurrentTier.percentCompletion < nextTier.percentCompletion)
                    return vm.data.myCurrentTier.percentCompletion;
                else if (vm.data.myCurrentTier.percentCompletion > tier.percentCompletion)
                    return 100;
                return 0;
            };
        }
    });
}());
